export default "__VITE_ASSET__CykM0MuD__"